import styled, { css } from 'styled-components';

import { theme } from '../layout/theme';

interface LinkButtonProps {
  noDecoration?: boolean;
  align?: boolean;
  marginTop?: string;
}

export const LinkButton = styled.button<LinkButtonProps>`

${({ align }) =>
  align &&
  css`
    text-align: none;
  `}
  
${theme.screens.Md} {
  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: ${marginTop};
    `};
}

${({ noDecoration }) =>
  noDecoration &&
  css`
    text-decoration: none;
    `}

  display: inline-flex;
  align-items: center;
  color: ${theme.colors.text.link};
  text-align: left;
  font-size: 1em;
  max-width: 100%;

  &:hover {
    text-decoration: underline;
  }

  &.not-visable {
    visibility: hidden;
  }

  &.weight-thin {
    font-weight: ${theme.font.weight.thin};
  }

  &.weight-regular {
    font-weight: ${theme.font.weight.regular};
  }

  &.weight-medium {
    font-weight: ${theme.font.weight.medium};
  }

  &.weight-bold {
    font-weight: ${theme.font.weight.bold};
  }

  &.current-color {
    color: currentColor;
  }

  &.disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  &.full {
    display: flex;
    width: 100%;
  }

  &.nowrap {
    white-space: nowrap;
  }
`;
